import { Box } from '@mui/material';
import { GridColDef, GridRowModel, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { useQueryProdutos } from 'pages/compra/carrinho/hooks';
import { ProdutoPedidoProps } from 'pages/compra/carrinho/types';
import { brlPrice } from 'util/format';

type CarrinhoProdutoGrid = {
    row: GridRowModel;
};

/**
 * Retorna as informações para as linhas da grid formatadas de acordo com a request do produto.
 */
const getRows = (data: ProdutoPedidoProps[] = []): GridRowsProp =>
    data.map((item) => ({
        id: item.produto.cdProduto,
        vlTotal: item.vlTotal,
        qtPedido: item.qtPedido,
        vlUnitario: item.vlPreco,
        fgDisponivelCompra: item.fgDisponivelCompra,
        lkImagem: item.produto.lkImagem,
        cdProduto: item.produto.cdProduto,
        dsProduto: item.produto.dsProduto,
        qtMinimaCompra: item.produto.qtMinimaCompra,
        dsSubgrupo: item.produto.subgrupo.dsSubgrupo,
    }));

const columns: GridColDef[] = [
    {
        field: 'imagem',
        align: 'center',
        headerAlign: 'center',
        headerName: 'Imagem',
        filterable: false,
        sortable: false,
        minWidth: 50,
        renderCell: ({ row }) =>
            row.lkImagem ? (
                <Box
                    sx={{
                        minWidth: 50,
                        minHeight: 50,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        backgroundImage: `url("${row.lkImagem}")`,
                        borderRadius: 1,
                        border: (theme) => `1px solid ${theme.palette.grey[400]}`,
                    }}
                />
            ) : null,
    },
    { field: 'cdProduto', headerName: 'Código de integração', width: 120, minWidth: 90 },
    { field: 'dsProduto', headerName: 'Produto', flex: 1, minWidth: 100 },
    { field: 'dsSubgrupo', headerName: 'Categoria', flex: 1, minWidth: 110 },
    {
        field: 'vlUnitario',
        headerName: 'Preço unitário',
        type: 'number',
        align: 'right',
        width: 130,
        minWidth: 110,
        valueFormatter: (value) => (value ? brlPrice(value) : null),
    },
    { field: 'qtMinimaCompra', headerName: 'Quantidade mínima', minWidth: 100 },
    { field: 'qtPedido', headerName: 'Quantidade do pedido', minWidth: 100 },
    {
        field: 'vlTotal',
        headerName: 'Valor no pedido',
        type: 'number',
        align: 'right',
        width: 130,
        minWidth: 110,
        valueFormatter: (value) => (value ? brlPrice(value) : null),
    },
    { field: 'fgDisponivelCompra', headerName: 'Disponível para compra', type: 'boolean', minWidth: 100 },
];

export function CarrinhoProdutoGrid({ row }: CarrinhoProdutoGrid) {
    const { isFetching, data, refetch } = useQueryProdutos({ row });

    return (
        <Box sx={{ m: 2 }}>
            <PanelGrid rows={getRows(data)} loading={isFetching} reload={refetch} columns={columns} remote={false} />
        </Box>
    );
}
